// Styles
import "./apps-header.scss";
// Components
import { SortStatus } from "../../../../../../../../../../shared/components/sort-status/SortStatus";
import { CostTooltip } from "../../../../../../../../../../shared/components/cost-tooltip/CostTooltip";
import { useCostTooltipHeaderPhase } from "../../../../../../../../../../shared/components/cost-tooltip/use-cost-tooltip-header-phase";

interface Props {
	setSortInfo: {
		sortMethod: string;
		sortBy: string;
	};
	handleSort: (method: string, by: string) => void;
	totalCostUsd: number;
}

export const AppsHeader = ({
	setSortInfo,
	handleSort,
	totalCostUsd,
}: Props) => {
	const isActive = (by: string) => setSortInfo.sortBy === by;

	const {
		onCostCellEnter,
		onCostCellLeave,
		onCostTooltipCloseAnimationEnd,
		phaseClasses,
	} = useCostTooltipHeaderPhase();

	const onHeaderClick = (by: string) => {
		const currentlyActive = isActive(by);
		const currentMethod = setSortInfo.sortMethod;
		const newMethod =
			currentlyActive && currentMethod === "asc" ? "desc" : "asc";
		handleSort(newMethod, by);
	};

	return (
		<div className='apps-header'>
			<div className='apps-header__wrapper window-header-wrapper'>
				<div
					onClick={() => onHeaderClick("app")}
					onMouseDown={(e) => e.preventDefault()}
					className={`apps-header__name window-header-item ${isActive("app") ? "active" : ""}`}>
					<div>App</div>
					<SortStatus
						status={isActive("app") ? setSortInfo.sortMethod : "unactive"}
					/>
				</div>
				<div
					onClick={() => onHeaderClick("status")}
					onMouseDown={(e) => e.preventDefault()}
					className={`apps-header__status window-header-item ${isActive("status") ? "active" : ""}`}>
					<div>Status</div>
					<SortStatus
						status={isActive("status") ? setSortInfo.sortMethod : "unactive"}
					/>
				</div>
				<div
					onMouseEnter={onCostCellEnter}
					onMouseLeave={onCostCellLeave}
					onClick={() => onHeaderClick("cost")}
					onMouseDown={(e) => e.preventDefault()}
					className={`apps-header__cost window-header-item ${isActive("cost") ? "active" : ""}${phaseClasses}`}>
					<CostTooltip
						cost={totalCostUsd}
						onCloseAnimationEnd={onCostTooltipCloseAnimationEnd}
					/>
					<div>Cost</div>
					<SortStatus
						status={isActive("cost") ? setSortInfo.sortMethod : "unactive"}
					/>
				</div>
			</div>
		</div>
	);
};
